module.exports = __webpack_public_path__ + "static/media/serieHD.c804794c.pdf";